const UQL_OPS = {
  GREATERTHAN: 'GT',
  GREATERTHANOREQ: 'GE',
  LESSTHAN: 'LT',
  LESSTHANOREQ: 'LE',
  EQUALS: 'EQ',
  NOTEQUALS: 'NE',
  LIKE: 'LK',
  LIKEIGNORECASE: 'IL',
  CONTAINS: 'CN',
  CONTAINSIGNORECASE: 'CI',
  NOTCONTAINS: 'NC',
  NOTCONTAINSIGNORECASE: 'NI',
  STARTSWITH: 'SW',
  STARTSWITHIGNORECASE: 'SI',
  ENDSWITH: 'EW',
  ENDSWITHIGNORECASE: 'EI',
  ISNULL: 'NL',
  ISNOTNULL: 'NN',
  EQUALSDAYS: 'ED',
  GREATERTHANDAYS: 'GD',
  LESSTHANDAYS: 'LD',
  // related collection
  ANYEXISTS: 'AN',
  NOTANYEXISTS: 'NA',
  // related objects
  HAS: 'HS',
  NOTHAS: 'NH',
};

const constants = {
  DELIM: String.fromCharCode(27), // <esc> 0x1B
  CURRENT_DATE: `${String.fromCharCode(30)}CURRENT_DATE`, // <rs> 0x1E
  CURRENT_TIMESTAMP: `${String.fromCharCode(30)}CURRENT_TIMESTAMP`, // <rs> 0x1E
  PERCENTSIGN: String.fromCharCode(37), // '%' 0x25
  FIELD_AUTH: '_fieldauth',
  DB_TRUE: 'Y',
  DB_FALSE: 'N',
  ...UQL_OPS,
};

const timeConstants = {
  DATEFORMAT: 'yyyy-MM-dd',
  DATETIMEFORMAT: 'yyyy-MM-dd HH:mm:ss.u',
  UQLDATEFORMAT: 'dd-MMM-yyyy',
};

// REFACTOR: this doesn't belong in constants.js
const translateWilds = (str) => str.replace(/\*/g, constants.PERCENTSIGN);

// REFACTOR: this doesn't belong in constants.js
const translateWildsFor = (str, op) => {
  if (str === null) return '';
  if (op === constants.LIKE || op === constants.LIKEIGNORECASE) return translateWilds(str);
  return str;
};

const EMPTY_PRODUCTID = 'Click here to edit...';

const UNDO = `${constants.DELIM}UNDO${constants.DELIM}`;

const PERCENT_PRECISION = 4;

const ORDER_TYPELABEL = {
  SAL: 'Sale',
  RES: 'Reservation',
  MCR: 'Credit',
  MDB: 'Debit',
  CRM: 'Return',
  EEX: 'Exchange',
  SER: 'Service Order',
};

const OrderDetailCommissionPerms = {
  SAL: 'orderdetailchngcomm',
  RES: 'orderdetailchngcomm',
  CRM: 'orderreturndetailchngcomm',
  EEX: 'orderexchangedetailchngcomm',
  MCR: 'ordercreditdetailchngcomm',
  MDB: 'orderdebitdetailchngcomm',
};

module.exports = {
  constants,
  timeConstants,
  translateWilds,
  translateWildsFor,
  UQL_OPS,
  EMPTY_PRODUCTID,
  ORDER_TYPELABEL,
  UNDO,
  PERCENT_PRECISION,
  OrderDetailCommissionPerms,
};
